import React from 'react'

import { Container, ContentHeader, Page } from 'components'
import { PmcForm } from './components'

const PmcNew = () => {
  return (
    <Page title="Criação de Plano de Melhoria Contínua (PMC)">
      <Container maxWidth={false}>
        <ContentHeader title="Plano de Melhoria Contínua (PMC)" />
        <PmcForm />
      </Container>
    </Page>
  )
}

export default PmcNew
